import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const Checklist = ({ children }) => <ul className='checklist'>{children}</ul>
Checklist.propTypes = { children: PropTypes.any.isRequired }

export default Checklist
